import React, { useEffect } from 'react';
import useProcessDefinitionService from 'domain/gpo/cockpit/definition/processDefinitionService';
import { DataGridLayout, List, ListHeader, ListPageLayout } from 'framework/list';
import { NumberField } from 'framework/ui/field';
import ProcessDefinitionLinkField from 'domain/gpo/cockpit/definition/shared/ProcessDefinitionLinkField';
import IncidentsCount from 'domain/gpo/cockpit/definition/List/IncidentsCount';
import useProcessInstanceService from 'domain/gpo/cockpit/instance/processInstanceService';

const ProcessDefinitionListPage = () => {
  const { search } = useProcessDefinitionService();
  const { cacheProcessKeys } = useProcessInstanceService();

  useEffect(() => {
    cacheProcessKeys();
  }, [cacheProcessKeys]);

  return (
    <List getDataMethod={search}>
      <ListPageLayout header={<ListHeader label="Definitions" icon="fa-file-text" />}>
        <IncidentsCount />
        <DataGridLayout showTotal={false} isSmallTable>
          <ProcessDefinitionLinkField source="key" />
          <NumberField source="activeInstancesCount" label="Active instances" />
          <NumberField source="activeIncidentsCount" label="Incidents" />
        </DataGridLayout>
      </ListPageLayout>
    </List>
  );
};

export default ProcessDefinitionListPage;
